import {
  LocalAudioTrack,
  LocalVideoTrack,
  RemoteAudioTrack,
  RemoteVideoTrack,
} from 'twilio-video'

import { Nullable } from '@shared/models/types/primary'

export interface Attachment {
  label: string
  icon: string
  id: string
  formId: number
}

export interface AcResults {
  isCamOK: boolean
  isMicOK: boolean
  isAudioOK: boolean
  /* not checking for now, so always true */
  isConnectOK: boolean
  /* */
  snapshot: Nullable<string>
  cameraLabel: string
  micLabel: string
  speakerLabel: string
  allPassed: boolean
  isValidBrowser: boolean
  browserInfo: {
    browser: string
    os: string
    version: string
    device: string
  }
}

export interface AttachTracksEvent {
  tracks: Nullable<
    LocalAudioTrack | LocalVideoTrack | RemoteAudioTrack | RemoteVideoTrack
  >[]
  isLocal: boolean
  isSecond?: boolean
  participantRole?: ParticipantRole
}

export enum ParticipantRole {
  INTERPRETER = 'interpreter',
  USER = 'user',
  VIDEO_CALL_GUEST = 'video_call_guest',
  PATIENT = 'patient',
  VISITOR = 'visitor',
}

export interface FeedbackForm {
  feedbackComment: string
  feedbackRating: number
}

export enum ParticipantIdentitiesKeys {
  SECOND = 'second',
  FIRST = 'first',
}
